<template>
    <div class="sidebar--filter_active"
         :class="[
             isFiltersOpen ? 'left-0 z-50' : '-left-[290px]',
             withFilter && isFiltersOpen ? 'filtersOn' : 'filterOff'
         ]"
    >
        <div class="sidebar--wrapper">
            <div v-if="withFilter" class="header--sidebar">
                <button type="button" @click.prevent="handleCloseFilters" class="close--btn">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21.69" height="13.724"  fill="#000000" viewBox="0 0 21.69 20.724">
                        <g id="Groupe_9" data-name="Groupe 9" transform="translate(-258.959 -31.138)">
                            <line id="Ligne_1" data-name="Ligne 1" x2="21" y2="20" transform="translate(259.304 31.5)" fill="none" stroke="#000" stroke-width="1"/>
                            <line id="Ligne_3" data-name="Ligne 3" y1="20" x2="21" transform="translate(259.304 31.5)" fill="none" stroke="#000" stroke-width="1"/>
                        </g>
                    </svg>
                </button>
            </div>
            <div v-if="project && withFilter" class="filters--ch">
                <h3>{{ t('Critère de sélection', 'Critère de sélection') }} : </h3>
                <template v-if="project.show_category">
                    <h4>{{ t('Catégorie(s)', 'Catégorie(s)') }}</h4>
                    <ul>
                        <li v-for="category in categories">
                            <label :for="`category-${category.id}`" class="w-full flex flex-row items-center justify-between">
                                {{ category.name }}
                                <input type="checkbox" :id="`category-${category.id}`" name="categories[]" :value="category.id" v-model="searchQuery.categories" @change="handleSearchUnit">
                                <span class="check"></span>
                            </label>
                        </li>
                    </ul>
                </template>
                <template v-else>
                    <h4>
                        <template v-if="PROJECT_TOPOLOGY.labels[project.topology] === 'T'">
                            {{ t('Nombre de pièce(s)', 'Nombre de pièce(s)') }}
                        </template>
                        <template v-else>
                            {{ t('Nombre de chambre(s)', 'Nombre de chambre(s)') }}
                        </template>
                    </h4>
                    <ul>
                        <li v-for="bedroom in filterBedrooms">
                            <label :for="`bedroom-${bedroom}`" class="w-full flex flex-row items-center justify-between">
                                <template v-if="bedroom === 1">
                                    {{ PROJECT_TOPOLOGY.labels[project.topology] === 'T' ? t('ST', 'ST') : t('1 chambre', '1 chambre') }}
                                </template>
                                <template v-else-if="bedroom === 0">
                                    {{ t('0 chambre', '0 chambre') }}
                                </template>
                                <template v-else>
                                    {{ PROJECT_TOPOLOGY.labels[project.topology] === 'T' ?  `T${bedroom}` : `${bedroom} ${t('chambre(s)', 'chambre(s)')}` }}
                                </template>
                                <input type="checkbox" :id="`bedroom-${bedroom}`" name="bedrooms[]" :value="bedroom" v-model="searchQuery.bedrooms" @change="handleSearchUnit">
                                <span class="check"></span>
                            </label>
                        </li>
                    </ul>
                </template>
            </div>
            <div v-if="project && project.show_price && withFilter" class="sliders--price">
                <h4>{{ t('Prix', 'Prix') }}
                    <span class="price--content block">
                        {{ t('De', 'De') }} {{ new Intl.NumberFormat('fr-BE', {
                            style: 'currency',
                            currency: 'EUR',
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0
                        }).format(searchQuery.price[0])}}
                        {{ t('à', 'à') }} {{ new Intl.NumberFormat('fr-BE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(searchQuery.price[1]) }}
                    </span>
                </h4>
                <Slider
                    class="slider slider-pink"
                    v-model="searchQuery.price"
                    :min="0"
                    :max="maxPrice"
                    :step="maxPrice/100"
                    :lazy="true"
                    tooltipPosition="bottom"
                    :format="{
                        suffix: ' €',
                        thousand: ' ',
                        decimals: 0
                    }"
                    @change="handleSearchUnit"
                />
            </div>
            <div v-if="withFilter" class="sliders--surface">
                <h4>{{ t('Surface', 'Surface') }}
                    <span class="price--content block">
                        {{ t('De', 'De') }} {{ searchQuery.surface[0] }}
                        {{ t('à', 'à') }} {{ searchQuery.surface[1] }}
                    </span>
                </h4>

                <Slider
                    class="slider slider-pink"
                    v-model="searchQuery.surface"
                    :min="0"
                    :max="maxSurface"
                    :step="5"
                    :lazy="true"
                    tooltipPosition="bottom"
                    :format="{
                        suffix: ' m²',
                        thousand: ' ',
                        decimals: 0
                    }"
                    @change="handleSearchUnit"
                />
            </div>
            <div v-if="withFilter && (isGardenAvailable || isTerraceAvailable || isBalconyAvailable || isLoggiaAvailable)" class="filters--exterior">
                <h4>{{ t('Extérieur', 'Extérieur') }}</h4>
                <ul>
                    <li v-if="isGardenAvailable">
                        <label for="has_garden" class="w-full flex flex-row items-center justify-between">
                            {{ t('Jardin', 'Jardin') }}
                            <input type="checkbox" id="has_garden" name="options[]" value="has_garden" v-model="searchQuery.options" @change="handleSearchUnit">
                            <span class="check"></span>
                        </label>
                    </li>
                    <li v-if="isTerraceAvailable">
                        <label for="has_terrace" class="w-full flex flex-row items-center justify-between">
                            {{ t('Terrasse', 'Terrasse') }}
                            <input type="checkbox" id="has_terrace" name="options[]" value="has_terrace" v-model="searchQuery.options" @change="handleSearchUnit">
                            <span class="check"></span>
                        </label>
                    </li>
                    <li v-if="isBalconyAvailable">
                        <label for="has_balcony" class="w-full flex flex-row items-center justify-between">
                            {{ t('Balcon', 'Balcon') }}
                            <input type="checkbox" id="has_balcony" name="options[]" value="has_balcony" v-model="searchQuery.options" @change="handleSearchUnit">
                            <span class="check"></span>
                        </label>
                    </li>
                    <li v-if="isLoggiaAvailable">
                        <label for="has_loggia" class="w-full flex flex-row items-center justify-between">
                            {{ t('Loggia', 'Loggia') }}
                            <input type="checkbox" id="has_loggia" name="options[]" value="has_loggia" v-model="searchQuery.options" @change="handleSearchUnit">
                            <span class="check"></span>
                        </label>
                    </li>
                </ul>
            </div>
            <div v-if="withFilter && isDuplexAvailable" class="filters--exterior">
                <h4>{{ t('Type', 'Type') }}</h4>
                <ul class="w-full">
                    <li v-if="isDuplexAvailable">
                        <label for="is_duplex" class="w-full flex flex-row items-center justify-between">
                            {{ t('Duplex', 'Duplex') }}
                            <input type="checkbox" id="is_duplex" name="isDuplex" v-model="searchQuery.isDuplex" @change="handleSearchUnit">
                            <span class="check"></span>
                        </label>
                    </li>
                </ul>
            </div>
            <button v-if="withFilter" type="button" @click.prevent="handleResetSearch" class="btn--main btn--reset w-full">
                {{ t('Réinitialiser', 'Réinitialiser') }}
            </button>
            <button v-if="withFilter" type="button" @click.prevent="handleSearchUnit" class="btn--main btn--search w-full">
                {{ t('Recherche', 'Recherche') }}
            </button>
        </div>
        <div :class="{'active--searchbar': isSectionOpen, 'sidebar--extend_wrapper': true}">
            <div class="sidebar--extend_content" :class="isResultsOpen && isSectionOpen ? 'add--content_extented block' : ''">
                <div class="header--sidebar_extend">
                    <h2>{{ t('Résultats', 'Résultats') }} : </h2>

                    <div class="filters--ch">
                        <ul>
                            <li>
                                <label for="filter--available">{{ t('Afficher les appartements indisponibles', 'Afficher les appartements indisponibles') }}
                                    <input type="checkbox" id="filter--available" name="selector" @change="handleSearchUnit" v-model="searchQuery.isUnavailable">
                                    <span class="check"></span>
                                </label>
                            </li>
                        </ul>
                    </div>
                </div>
                <template v-if="results.map( floor => floor.units.length ).reduce((sum, nbrUnits) => sum + nbrUnits, 0) > 0">
                    <template v-for="floor in results">
                        <div v-if="floor.units.length > 0 " class="filters--results">
                            <h3><span class="number--found">{{ floor.units.length }}</span> {{ floor.units.length > 1 ? t('appartements', 'appartements') : t('appartement', 'appartement') }} {{ t('correspondant à votre recherche au', 'correspondant à votre recherche au') }} "{{ floor.description }}"</h3>
                            <div v-for="unit in floor.units" class="line--results">
                                <span class="type uppercase">{{ unit.fullname ? unit.fullname : unit.name }}</span>
                                <span class="surface">{{ unit.surface }} m²</span>
                                <span v-if="project && project.show_price" class="price">
                                    {{ new Intl.NumberFormat('fr-BE', {
                                        style: 'currency',
                                        currency: 'EUR',
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 0
                                    }).format(unit.price)}}
                                </span>
                                <span class="exterior">
                                {{ unit.has_balcony ? t('Balcon', 'Balcon') : '' }}
                                {{ unit.has_terrace ? t('Terrasse', 'Terrasse') : '' }}
                                {{ unit.has_garden ? t('Jardin', 'Jardin') : '' }}
                                {{ unit.has_loggia ? t('Loggia', 'Loggia') : '' }}
                            </span>
                                <span class="availability" :class="unit?.status_id === 1 ? '' : 'no-available'">
                                    {{ unit.status && unit.status.translatable.name[locale] ? unit.status.translatable.name[locale] : unit.status.name }}
                                </span>
                                <span class="see--more"><button @click.prevent="handleShowUnit(unit)" class="btn--main">{{ t('Voir', 'Voir') }}</button></span>
                            </div>
                        </div>
                    </template>
                </template>
                <template v-else>
                    <p class="no--flat flex items-center justify-center">{{ t('Aucun bien ne correspond à ces critères de recherches', 'Aucun bien ne correspond à ces critères de recherches') }}</p>
                </template>
            </div>
            <Unit
                :class="isUnitOpen && isSectionOpen ? 'flex' : 'hide'"
                :current-unit="currentUnit"
                :project="project"
                :building="building"
                :floor="floor"
                :withFilter="withFilter"
                @closeUnit="handleCloseUnit"
                @closeFilters="handleCloseFilters"
            />
            <button v-if="(isSearchOpenedOnce || screenWidth <= 1100) && withFilter" type="button" @click.prevent="handleToggleSection" class="sidebar--extend">
                <span class="arrow--bg" :class="isSectionOpen ? 'rotate--searchbar' : ''">
                    <img :src="appUrl + '/img/orbitals/arrow.png'" alt="">
                </span>
            </button>
        </div>
    </div>
</template>

<script>
    import Unit from "../units/single"
    import Slider from '@vueform/slider'
    import PROJECT_TOPOLOGY from "../../enums/project-topology";
    import t from "../../composables/Translator";

    export default {
        beforeMount() {
            window.addEventListener("resize", this.handleScreenChange);
        },
        data() {
            return {
                isSearchDirty: false,
                searchQuery: {
                    bedrooms: [],
                    price: [0, this.maxPrice],
                    surface: [0, this.maxSurface],
                    options: [],
                    isUnavailable: true,
                    categories: [],
                    isDuplex: false
                },
                maxSurface: 1000,
                maxPrice: 250000,
                isGardenAvailable: true,
                isBalconyAvailable: true,
                isTerraceAvailable: true,
                isLoggiaAvailable: true,
                isDuplexAvailable: true,
                screenWidth: window.innerWidth,
                PROJECT_TOPOLOGY: PROJECT_TOPOLOGY,
                appUrl: process.env.MIX_APP_URL,
                isSearchOpenedOnce: false,
                filterBedrooms: []
            }
        },
        props: {
            isFiltersOpen: {type: Boolean, default: false},
            isUnitOpen: {type: Boolean, default: false},
            isResultsOpen: {type: Boolean, default: false},
            isSectionOpen: {type: Boolean, default: false},
            currentUnit: Object,
            statuses: Array,
            floors: Array,
            project: Object,
            building: Object,
            floor: Object,
            results: Array,
            categories: Array,
            withFilter: {type: Boolean, default: false},
        },
        watch: {
            isFiltersOpen() {
                if(this.floors.length > 0 && !this.isSearchDirty) {
                    let units = this.floors.map( floor => floor.units.data ).flat();

                    let maxPrice = Math.max(...units.map( unit => Number(unit.price) ))
                    this.searchQuery.price[1] = (maxPrice === Number.NEGATIVE_INFINITY ? 0 : maxPrice);
                    this.maxPrice = Math.ceil(maxPrice === Number.NEGATIVE_INFINITY ? 0 : maxPrice)

                    let maxSurface = Math.max(...units.map( unit => Number(unit.surface) ))
                    this.searchQuery.surface[1] = Math.ceil((maxSurface === Number.NEGATIVE_INFINITY ? 0 : maxSurface)/10)*10;
                    this.maxSurface = Math.ceil((maxSurface === Number.NEGATIVE_INFINITY ? 0 : maxSurface)/10)*10;

                    this.isGardenAvailable = units.filter( unit => unit.has_garden).length > 0;
                    this.isBalconyAvailable = units.filter( unit => unit.has_balcony).length > 0;
                    this.isTerraceAvailable = units.filter( unit => unit.has_terrace).length > 0;
                    this.isLoggiaAvailable = units.filter( unit => unit.has_loggia).length > 0;
                    this.isDuplexAvailable = units.some(unit => unit.unit_id !== null);

                    this.filterBedrooms = [];

                    units.forEach( unit => {
                        if(!this.filterBedrooms.includes(unit.bedrooms)) {
                            this.filterBedrooms.push(unit.bedrooms);
                        }
                    });
                    this.filterBedrooms.sort((a, b) => a - b);
                }
            },
            searchQuery: {
                handler(oldSearchQuery, newSearchQuery) {
                    if(JSON.stringify(oldSearchQuery) !== JSON.stringify(newSearchQuery)) {
                        this.isSearchDirty = true;
                    }

                    this.isSearchOpenedOnce = true;
                },
                deep: true
            },
            results() {
                if(this.results.map( floor => floor.units ).flat().map( unit => unit.name).length === 0) {
                    this.$emit('setSelectedUnit', null);
                }
            }
        },
        methods: {
            handleToggleSection() {
                if(this.screenWidth <= 1100) {
                    if(this.isSectionOpen) {
                        this.$emit('toggleResults')
                    }else{
                        if(this.isFiltersOpen) {
                            this.$emit('closeFilters')
                        }else{
                            this.$emit('openFilters')
                        }
                    }
                }else {
                    this.$emit('toggleResults')
                }
            },
            handleCloseFilters() {
                this.$emit('closeFilters')
            },
            handleCloseUnit() {
                this.$emit('closeUnit')
            },
            handleShowUnit(unit) {
                if(this.screenWidth <= 1100) {
                    this.$emit('showUnit', unit);
                }else {
                    this.$emit('setCurrentUnit', {unit: unit});
                }

                this.$emit('setSelectedUnit', unit);
            },
            handleSearchUnit() {
                this.$nextTick(() => {
                    this.$emit('search', {...this.searchQuery})
                    this.isSearchDirty = true;
                });
            },
            handleScreenChange() {
                this.screenWidth = window.innerWidth
            },
            handleResetSearch() {
                this.searchQuery = {
                    bedrooms: [],
                    price: [0, this.maxPrice],
                    surface: [0, this.maxSurface],
                    options: [],
                    isUnavailable: true,
                    categories: [],
                    isDuplex: false
                };

                this.$emit('resetResults');
            },
            t(...args) {
                return t(...args);
            }
        },
        computed: {
            locale() {
                return this.$store.getters['config/locale'];
            }
        },
        components: {
            Unit,
            Slider
        }
    }
</script>

<style scoped>
    .slider-pink {
        --slider-connect-bg: var(--base-color);
        --slider-tooltip-bg: var(--base-color);
        --slider-handle-bg: var(--base-color);
        --slider-handle-shadow: none;
        --slider-tooltip-font-weight: 200;
    }
</style>
